import upperFirst from "lodash/upperFirst";

export const pluralizeCopy = (copy, count) =>
  `${count} ${copy}${count === 1 ? "" : "s"}`;

export const formatUpperFirst = (copy) => upperFirst(copy.replace(/_/g, " "));
